var _mask, _g, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "q&a_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12.8,
    fill: "#E0E9FB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#q&a_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.185 33.975a9.759 9.759 0 01-2.804-6.851 9.75 9.75 0 019.752-9.752 9.75 9.75 0 019.753 9.752 9.75 9.75 0 01-9.753 9.752h-9.752l2.804-2.901z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.21 37.608h-6.827a.75.75 0 01-.683-.44c-.122-.267-.049-.584.146-.804l2.317-2.414a10.524 10.524 0 01-2.512-6.826c0-5.779 4.706-10.484 10.484-10.484 4.608 0 8.631 2.95 9.997 7.339a.74.74 0 01-1.415.438c-1.17-3.779-4.608-6.314-8.582-6.314-4.973 0-9.02 4.047-9.02 9.02 0 2.39.926 4.633 2.584 6.34.268.292.292.731 0 1.024l-1.585 1.658h5.096c.414 0 .731.317.731.731a.718.718 0 01-.731.732z",
    fill: "#E85388"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.836 43.727a9.715 9.715 0 002.803-6.85 9.75 9.75 0 00-9.752-9.753 9.75 9.75 0 00-9.752 9.752 9.75 9.75 0 009.752 9.753h9.752l-2.803-2.902z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.64 47.36h-9.753c-5.778 0-10.484-4.705-10.484-10.484 0-5.778 4.706-10.483 10.484-10.483s10.484 4.705 10.484 10.483c0 2.536-.902 4.925-2.536 6.827l2.316 2.414c.196.22.269.512.147.804a.692.692 0 01-.659.44zm-9.753-19.505c-4.974 0-9.02 4.048-9.02 9.021 0 4.974 4.046 9.021 9.02 9.021h8.021L43.3 44.24a.752.752 0 010-1.024c1.683-1.706 2.585-3.95 2.585-6.339.024-4.973-4.023-9.02-8.997-9.02z",
    fill: "#2661AD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.544 35.901H33.23a.718.718 0 01-.732-.731c0-.415.317-.732.732-.732h7.314c.414 0 .731.317.731.732a.718.718 0 01-.731.731zm-3.657 3.657H33.23a.718.718 0 01-.732-.731c0-.415.317-.732.732-.732h3.657c.414 0 .731.317.731.732a.718.718 0 01-.731.731zm3.657 0a.664.664 0 01-.512-.22.664.664 0 01-.22-.511c0-.049 0-.098.025-.146 0-.05.024-.098.048-.147.025-.048.05-.073.074-.122a.723.723 0 01.756-.317c.048 0 .097.025.146.05a.532.532 0 01.122.072.19.19 0 01.097.098c.025.024.073.073.098.122.024.049.048.073.073.122.024.048.024.097.049.146 0 .049.024.097.024.146 0 .195-.073.39-.22.512l-.097.098c-.049.024-.073.049-.122.073-.049.024-.097.024-.146.049-.098-.025-.146-.025-.195-.025z",
    fill: "#2661AD"
  })));
}
export default SvgQa;